import { selectAuth, setLoading } from "@redux";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { topCharoenAPI } from "src/API/topCharoen";
import { ComponentEventDetails } from "src/Components/EventActivity/EventDetails";
import { IGetWebsaleTopSpenderExample } from "src/Interfaces/topCharoen";

export const PageEventDetails = () => {
    const { userInfo } = useSelector(selectAuth);
    const dispatch = useDispatch();
    const history = useHistory();
    const [loggedInUser, setLoggedInUser] = useState<IGetWebsaleTopSpenderExample>();

    return <ComponentEventDetails userInfo={userInfo} loggedInUser={loggedInUser} />;
};
